import { configureStore } from "@reduxjs/toolkit";

/*********** reducers imports ************/
import authReducer from "../app/slices/authSlice";
import incidentsReducer from "../app/slices/incidentsSlice";
import eventsReducer from "../app/slices/eventsSlice";
import alertsReducer from "../app/slices/alertsSlice";
import reportsReducer from "../app/slices/reportsSlice";
import userReducer from "../app/slices/userSlice";
import advisoriesReducer from "../app/slices/advisoriesSlice";
import commonReducer from "./slices/commonSlice";
/*********** reducers imports ************/

export const store = configureStore({
  reducer: {
    auth: authReducer,
    incidents: incidentsReducer,
    events: eventsReducer,
    alerts: alertsReducer,
    reports: reportsReducer,
    advisories: advisoriesReducer,
    users: userReducer,
    common: commonReducer,
  },
});
